const messageTypes = [
  "atAddressPreciseGps",
  "atAddressImpreciseGps",
  "failedToAcquireGeoloc",
  "notAtAddress",
  "findOnMap",
  "trackingData",
  "deviceId",
];

export function validateInlineToPortalMessage(data: any): boolean {
  return (
    !!data &&
    typeof data === "object" &&
    data.source === "okhi" &&
    messageTypes.indexOf(data.payload?.type) !== -1
  );
}
